<template>
  <div id="pricing" class="pricing-wrap style1 pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Our Pricing Plan</span>
            <h2>
              Our High Quality <span> Easy Price</span> Without Any Hidden Fees
            </h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="pricing in pricings"
          :key="pricing.id"
        >
          <div class="pricing-table style1">
            <div class="pricing-header">
              <h5>{{ pricing.title }}</h5>
              <div class="pricing-header-tag">
                <h3>
                  ${{ pricing.price }} <span>/Per {{ pricing.period }}</span>
                </h3>
                <p>The perfect way To get started &amp; get used</p>
              </div>
            </div>

            <div class="pricing-features">
              <h5>Our Best Features:</h5>
              <ul class="list-style">
                <li
                  v-for="feature in pricing.features"
                  :key="feature.id"
                  :class="feature.class"
                >
                  <i class="ri-check-double-line"></i>
                  {{ feature.text }}
                </li>
              </ul>
            </div>

            <div class="purchase-pricing">
              <a href="#" class="btn style1">Choose This Plan</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurPricing",
  data: () => ({
    pricings: [
      {
        id: 1,
        title: "Starter",
        price: "15",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "unchecked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "unchecked",
            text: "Dental Services",
          },
        ],
      },
      {
        id: 2,
        title: "Professional",
        price: "20",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "checked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "unchecked",
            text: "Dental Services",
          },
        ],
      },
      {
        id: 3,
        title: "Institution",
        price: "45",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "checked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "checked",
            text: "Dental Services",
          },
        ],
      },
    ],
  }),
});
</script>